module.exports = __webpack_public_path__ + "static/media/address.da05ba21.svg";